'use strict';

var EPSILON = 2.220446049250313e-16; // Number.EPSILON
var INVERSE_EPSILON = 1 / EPSILON;
module.exports = function (n) {
  return n + INVERSE_EPSILON - INVERSE_EPSILON;
};